import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=92505eca&lang=pug"
import script from "./NewComment.vue?vue&type=script&lang=ts"
export * from "./NewComment.vue?vue&type=script&lang=ts"
import style0 from "./NewComment.vue?vue&type=style&index=0&id=92505eca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports